import { literal, object, type InferOutput } from "valibot"
import { InputProfilePresetIdSchema } from "../../../event/InputRouter/InputProfilePreset/InputProfilePresetId.enum"
import { StorageKind } from "../StorageKind/StorageKind.enum"

export const StoredItemMetaPresetSchema = object({
  kind: literal(StorageKind.Preset),
  // refers to an immutable object in the game's code.
  id: InputProfilePresetIdSchema,
})

export type StoredItemMetaPreset = InferOutput<typeof StoredItemMetaPresetSchema>
